(function () {
    'use strict';

    angular.module('swif.openbase')
    .directive('swifBookables', ['dataService', function (data) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: true,
            templateUrl: 'partials/openbase/swif_bookables.html',
            scope: {
                labelSite: '@?',
                labelEquipment: '@?',
                labelUser: '@?',
                labelTeam: '@?',
                filter: '=?'
            },
            link: function (scope, element, attr, ngModel) {
                scope.proxy = {sites: [], equipments: [], users: [], teams: [], merged: []};
                scope.filters = {sites: {}, equipments: {}, users: {}, teams: {}};

                var f = {};
                if (scope.filter) {
                    f = angular.copy(scope.filter);
                }
                data.addFilter(f, '|');
                data.addFilter(f, 'internal_booking', '=', true);
                data.addFilter(f, 'external_booking', '=', true);
                scope.filters.sites = angular.copy(f);
                data.addFilter(scope.filters.sites, 'type_prod', '=', 'site');
                scope.filters.equipments = angular.copy(f);
                data.addFilter(scope.filters.equipments, 'type_prod', '=', 'materiel');
                scope.filters.users = angular.copy(scope.filter);
                data.addFilter(scope.filters.users, 'type_prod', '=', 'user');
                scope.filters.teams = angular.copy(scope.filter);
                data.addFilter(scope.filters.teams, 'type_prod', '=', 'team');

                ngModel.$render = function (){
                    var val = ngModel.$viewValue || [];
                    var filter = {fields: ['type_prod']};
                    data.addFilter(filter, 'id', 'in', val);
                    data.get('product', undefined, filter)
                    .then(function (result) {
                        scope.proxy.sites = _.pluck(
                            _.filter(angular.copy(result), {type_prod: 'site'}),
                            'id'
                        );
                        scope.proxy.equipments = _.pluck(
                            _.filter(angular.copy(result), {type_prod: 'materiel'}),
                            'id'
                        );
                        scope.proxy.users = _.pluck(
                            _.filter(angular.copy(result), {type_prod: 'user'}),
                            'id'
                        );
                        scope.proxy.teams = _.pluck(
                            _.filter(angular.copy(result), {type_prod: 'team'}),
                            'id'
                        );
                        // merged is the hash that will contain the final value,
                        // the one returned to the host after each user input
                        scope.proxy.merged = angular.copy(_.pluck(result, 'id'));

                    });
                };

                scope.$watch('proxy.merged', function (newV, oldV) {
                    if (!angular.equals(newV, oldV) && _.isArray(newV) && oldV) {
                        ngModel.$setViewValue(newV);
                    }
                });

                scope.$watchGroup(['proxy.sites', 'proxy.equipments', 'proxy.users', 'proxy.teams'], function (newV, oldV) {
                    if (!angular.equals(newV, oldV)) {
                        var val = _.union(newV[0], newV[1], newV[2], newV[3]).sort();
                        scope.proxy.merged = val;
                    }
                });

            }
        };
    }]);

})();
